(function () {
  if (window.__shopifyCustomLightboxInjected) return;
  const contentExists = document.querySelector(
    ".rte, .page-content, .article, article",
  );
  if (!contentExists) return;

  window.__shopifyCustomLightboxInjected = true;

  const tpl = document.createElement("div");
  tpl.innerHTML = `
    <div class="shopify-custom-lightbox" aria-hidden="true" role="dialog" aria-modal="true">
      <div class="shopify-custom-lightbox__inner" tabindex="0">
        <img class="shopify-custom-lightbox__img" alt="" />
      </div>
      <button class="shopify-custom-lightbox__close" aria-label="Close (Esc)">✕</button>
      <div class="shopify-custom-lightbox__controls" aria-hidden="false">
        <button class="shopify-custom-lightbox__btn zoom-out" title="Zoom out">−</button>
        <button class="shopify-custom-lightbox__btn zoom-in" title="Zoom in">+</button>
      </div>
    </div>
  `;
  const lightboxEl = tpl.firstElementChild;
  const inner = lightboxEl.querySelector(".shopify-custom-lightbox__inner");
  const lbImg = lightboxEl.querySelector(".shopify-custom-lightbox__img");
  const btnClose = lightboxEl.querySelector(".shopify-custom-lightbox__close");
  const btnZoomIn = lightboxEl.querySelector(".zoom-in");
  const btnZoomOut = lightboxEl.querySelector(".zoom-out");
  document.body.appendChild(lightboxEl);

  // Semua elemen focusable di dalam lightbox
  const focusableEls = [btnClose, btnZoomIn, btnZoomOut, inner];

  function setFocusable(enabled) {
    focusableEls.forEach((el) => {
      if (enabled) {
        el.removeAttribute("tabindex");
      } else {
        el.setAttribute("tabindex", "-1");
      }
    });
  }

  // Set tidak focusable di awal (lightbox tertutup)
  setFocusable(false);

  let currentScale = 1,
    naturalWidth = 0,
    naturalHeight = 0,
    baseFitScale = 1,
    lastFocusedEl = null;
  let startX = 0,
    startY = 0,
    offsetX = 0,
    offsetY = 0,
    isDragging = false,
    lastDistance = null;

  function pickBestSrc(imgEl) {
    const ds = imgEl.dataset || {};
    if (ds.srcset) return pickFromSrcset(ds.srcset);
    if (ds.src) return ds.src;
    if (imgEl.getAttribute("srcset"))
      return pickFromSrcset(imgEl.getAttribute("srcset"));
    if (imgEl.getAttribute("data-srcset"))
      return pickFromSrcset(imgEl.getAttribute("data-srcset"));
    return imgEl.currentSrc || imgEl.src || null;
  }
  function pickFromSrcset(srcset) {
    try {
      const parts = srcset
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      if (!parts.length) return null;
      return (
        parts[parts.length - 1].split(" ")[0].trim() ||
        parts[0].split(" ")[0].trim()
      );
    } catch {
      return null;
    }
  }

  function computeBaseFitScale(imgW, imgH) {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0,
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0,
    );

    if (vw <= 640) {
      const scale = Math.min((vw * 0.98) / imgW, (vh * 0.98) / imgH);
      return Math.min(Math.max(scale, 0.7), 1.25);
    }

    const fitX = (vw * 0.94) / imgW;
    const fitY = (vh * 0.9) / imgH;
    return Math.max(Math.min(fitX, fitY, 1), 0.28);
  }

  function openLightboxFrom(imgEl) {
    const src = pickBestSrc(imgEl);
    if (!src) return;
    lastFocusedEl = document.activeElement;
    lockBodyScroll(true);
    lbImg.style.transform = "scale(1) translate(0px,0px)";
    lbImg.style.opacity = "0";
    offsetX = 0;
    offsetY = 0;
    lightboxEl.classList.add("open");
    lightboxEl.setAttribute("aria-hidden", "false");
    setFocusable(true);

    const preload = new Image();
    preload.onload = function () {
      naturalWidth = preload.naturalWidth || preload.width;
      naturalHeight = preload.naturalHeight || preload.height;
      baseFitScale = computeBaseFitScale(naturalWidth, naturalHeight);
      currentScale = baseFitScale;
      lbImg.src = preload.src;
      lbImg.alt = imgEl.alt || imgEl.getAttribute("alt") || "";
      lbImg.style.transform = `scale(${currentScale}) translate(0px,0px)`;
      lbImg.style.opacity = "1";
      inner.focus();
    };
    preload.onerror = function () {
      lbImg.src = src;
      lbImg.alt = imgEl.alt || "";
      baseFitScale = currentScale = 1;
      lbImg.style.transform = "scale(1) translate(0px,0px)";
      lbImg.style.opacity = "1";
      inner.focus();
    };
    preload.src = src;
  }

  function closeLightbox() {
    lightboxEl.classList.remove("open");
    lightboxEl.setAttribute("aria-hidden", "true");
    setFocusable(false);
    lbImg.style.opacity = "0";
    currentScale = baseFitScale;
    offsetX = offsetY = 0;
    lbImg.style.transform = `scale(${currentScale}) translate(0px,0px)`;
    lockBodyScroll(false);
    try {
      if (lastFocusedEl && lastFocusedEl.focus) lastFocusedEl.focus();
    } catch {}
  }

  let scrollTopBefore = 0;
  function lockBodyScroll(lock) {
    if (lock) {
      scrollTopBefore = window.scrollY || window.pageYOffset || 0;
      document.documentElement.style.scrollBehavior = "auto";
      document.body.style.top = `-${scrollTopBefore}px`;
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    } else {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollTopBefore);
      document.documentElement.style.scrollBehavior = "";
    }
  }

  function applyScale(scale) {
    const prevScale = currentScale;
    const clamped = Math.max(baseFitScale, Math.min(scale, baseFitScale * 6));
    const wasZoomedIn = currentScale > baseFitScale + 0.02;
    const isReset = clamped <= baseFitScale + 0.01;

    currentScale = clamped;

    if (isReset && wasZoomedIn) {
      offsetX = 0;
      offsetY = 0;
      lbImg.style.transition = "transform 0.25s ease-out";
      updateTransform();
      setTimeout(() => {
        lbImg.style.transition = "";
      }, 250);
      return;
    }

    updateTransform();
  }

  function zoomIn() {
    applyScale(currentScale * 1.25);
  }
  function zoomOut() {
    applyScale(currentScale / 1.25);
  }
  function clampOffsets() {
    if (!naturalWidth || !naturalHeight) return;

    if (currentScale <= baseFitScale + 0.01) {
      offsetX = 0;
      offsetY = 0;
      return;
    }

    const vw = window.innerWidth || document.documentElement.clientWidth;
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const isMobile = vw <= 640;
    const mobileFactor = 0.3;
    const factor = isMobile ? mobileFactor : 1;

    const displayedW = naturalWidth * currentScale;
    const displayedH = naturalHeight * currentScale;
    const overflowX = Math.max(0, (displayedW - vw) / 2);
    const overflowY = Math.max(0, (displayedH - vh) / 2);

    const maxTranslateX = overflowX * factor;
    const maxTranslateY = overflowY * factor;
    const maxOffsetX = maxTranslateX / currentScale;
    const maxOffsetY = maxTranslateY / currentScale;

    offsetX = Math.max(-maxOffsetX, Math.min(maxOffsetX, offsetX));
    offsetY = Math.max(-maxOffsetY, Math.min(maxOffsetY, offsetY));
  }

  function updateTransform() {
    clampOffsets();
    lbImg.style.transform = `scale(${currentScale}) translate(${offsetX}px,${offsetY}px)`;
  }

  btnClose.addEventListener("click", closeLightbox);
  lightboxEl.addEventListener("click", (e) => {
    if (e.target === lightboxEl) closeLightbox();
  });
  document.addEventListener("keydown", (e) => {
    if (!lightboxEl.classList.contains("open")) return;
    if (e.key === "Escape") {
      e.preventDefault();
      closeLightbox();
    }
    if (e.key === "+" || e.key === "=") {
      e.preventDefault();
      zoomIn();
    }
    if (e.key === "-") {
      e.preventDefault();
      zoomOut();
    }
  });
  btnZoomIn.addEventListener("click", (e) => {
    e.stopPropagation();
    zoomIn();
  });
  btnZoomOut.addEventListener("click", (e) => {
    e.stopPropagation();
    zoomOut();
  });

  lightboxEl.addEventListener(
    "wheel",
    (e) => {
      if (!lightboxEl.classList.contains("open")) return;
      e.preventDefault();

      const imgCenterX =
        (window.innerWidth || document.documentElement.clientWidth) / 2;
      const imgCenterY =
        (window.innerHeight || document.documentElement.clientHeight) / 2;
      const cursorX = e.clientX - imgCenterX;
      const cursorY = e.clientY - imgCenterY;

      const zoomFactor = e.deltaY < 0 ? 1.08 : 0.92;
      const newScale = currentScale * zoomFactor;
      const prevScale = currentScale;
      const prevOffsetX = offsetX;
      const prevOffsetY = offsetY;

      applyScale(newScale);
      const scaleRatio = currentScale / prevScale;
      offsetX = prevOffsetX - cursorX * (scaleRatio - 1);
      offsetY = prevOffsetY - cursorY * (scaleRatio - 1);

      if (currentScale <= baseFitScale + 0.01) {
        offsetX = offsetY = 0;
      }
      updateTransform();
    },
    { passive: false },
  );

  let dragActive = false,
    dragStartX = 0,
    dragStartY = 0,
    velocityX = 0,
    velocityY = 0,
    rafId = null;
  function animateDrag() {
    if (!dragActive) {
      velocityX *= 0.12;
      velocityY *= 0.12;
      offsetX += velocityX;
      offsetY += velocityY;
      if (Math.abs(velocityX) < 0.5 && Math.abs(velocityY) < 0.5) {
        velocityX = velocityY = 0;
        cancelAnimationFrame(rafId);
        rafId = null;
        updateTransform();
        return;
      }
    }
    updateTransform();
    rafId = requestAnimationFrame(animateDrag);
  }

  lbImg.addEventListener("mousedown", (e) => {
    if (currentScale <= baseFitScale) return;
    dragActive = true;
    lbImg.style.cursor = "grabbing";
    dragStartX = e.clientX - offsetX;
    dragStartY = e.clientY - offsetY;
    if (!rafId) rafId = requestAnimationFrame(animateDrag);
    e.preventDefault();
  });
  window.addEventListener("mousemove", (e) => {
    if (!dragActive) return;
    const targetX = e.clientX - dragStartX;
    const targetY = e.clientY - dragStartY;
    velocityX = (targetX - offsetX) * 0.6;
    velocityY = (targetY - offsetY) * 0.6;
    offsetX += velocityX;
    offsetY += velocityY;
  });
  window.addEventListener("mouseup", () => {
    if (dragActive) {
      dragActive = false;
      lbImg.style.cursor = "grab";
    }
  });

  let lastTouchDist = 0,
    lastTouchX = 0,
    lastTouchY = 0,
    momentumID = null;
  function applyMomentum() {
    offsetX += velocityX;
    offsetY += velocityY;
    velocityX *= 0.88;
    velocityY *= 0.88;
    updateTransform();
    if (Math.abs(velocityX) > 0.5 || Math.abs(velocityY) > 0.5) {
      momentumID = requestAnimationFrame(applyMomentum);
    } else {
      cancelAnimationFrame(momentumID);
    }
  }

  lbImg.addEventListener("touchstart", (e) => {
    cancelAnimationFrame(momentumID);
    if (e.touches.length === 1 && currentScale > baseFitScale) {
      isDragging = true;
      dragStartX = e.touches[0].clientX - offsetX;
      dragStartY = e.touches[0].clientY - offsetY;
      lastTouchX = e.touches[0].clientX;
      lastTouchY = e.touches[0].clientY;
    } else if (e.touches.length === 2) {
      isDragging = false;
      lastTouchDist = getDistance(e.touches[0], e.touches[1]);
    }
  });

  lbImg.addEventListener(
    "touchmove",
    (e) => {
      if (!lightboxEl.classList.contains("open")) return;
      if (e.touches.length === 1 && isDragging) {
        e.preventDefault();
        const touchX = e.touches[0].clientX;
        const touchY = e.touches[0].clientY;

        const dx = touchX - lastTouchX;
        const dy = touchY - lastTouchY;
        velocityX = dx * 0.25;
        velocityY = dy * 0.25;

        offsetX = touchX - dragStartX;
        offsetY = touchY - dragStartY;

        if (!rafId) {
          rafId = requestAnimationFrame(() => {
            updateTransform();
            rafId = null;
          });
        }

        lastTouchX = touchX;
        lastTouchY = touchY;
      } else if (e.touches.length === 2) {
        const dist = getDistance(e.touches[0], e.touches[1]);
        const scaleFactor = dist / lastTouchDist;
        lastTouchDist = dist;
        applyScale(currentScale * scaleFactor);
      }
    },
    { passive: false },
  );

  lbImg.addEventListener("touchend", (e) => {
    if (e.touches.length === 0 && isDragging) {
      isDragging = false;
      momentumID = requestAnimationFrame(applyMomentum);
    }
    if (e.touches.length < 2) lastTouchDist = 0;
  });

  function getDistance(t1, t2) {
    return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
  }

  const containerSelectors = [
    "#MainContent",
    ".rte",
    ".page-content",
    ".article",
    "article",
  ];
  const containers = containerSelectors
    .map((s) => document.querySelector(s))
    .filter(Boolean);
  const delegateRoot = containers.length ? containers[0] : document.body;

  delegateRoot.addEventListener("click", (e) => {
    const clickedImg = e.target.closest("img");
    if (!clickedImg) return;
    if (!isInsidePageOrArticle(clickedImg)) return;
    if (
      clickedImg.closest(
        ".destination-section-card, .no-expand, .carousel, .hero-banner, .product__media-item, .product__media, .product-media-container, [data-product-media-type]",
      )
    )
      return;

    const rect = clickedImg.getBoundingClientRect();
    const isBigEnough = rect.width > 150 && rect.height > 100;

    const isInsideContent = clickedImg.closest(
      ".rte-page, .article, .page-content, .article-content, .articles-container, .bannerpage-container, .article-template__content, .tour-card, .image-group, .our-team-image, .owner-image, .sidebar-image, .railpass-map",
    );

    if (!isInsideContent || !isBigEnough) return;

    e.preventDefault();
    openLightboxFrom(clickedImg);
  });

  function isInsidePageOrArticle(el) {
    return Boolean(
      el.closest("#MainContent") ||
        el.closest(".rte") ||
        el.closest(".page-content") ||
        el.closest("article") ||
        el.closest(".article"),
    );
  }

  inner.addEventListener("keydown", (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      inner.focus();
    }
  });
  window.addEventListener("resize", () => {
    if (!lightboxEl.classList.contains("open")) return;
    if (naturalWidth && naturalHeight) {
      baseFitScale = computeBaseFitScale(naturalWidth, naturalHeight);
      if (currentScale < baseFitScale) currentScale = baseFitScale;
      updateTransform();
    }
  });
})();

(function () {
  if (window.__productLightboxInjected) return;

  const productContainer = document.querySelector(
    ".product__media-item, [data-product-media-type], .product__description, .product-media-container",
  );
  if (!productContainer) return;

  window.__productLightboxInjected = true;
  const tpl = document.createElement("div");
  tpl.innerHTML = `
    <div class="product-lightbox" aria-hidden="true" role="dialog" aria-modal="true">
      <button class="product-lightbox__close" aria-label="Close (Esc)">✕</button>
      <button class="product-lightbox__nav prev">
        <svg width="20" height="25" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.292282 5.65703L5.94928 2.67029e-05L7.36328 1.41403L2.41328 6.36403L7.36328 11.314L5.94928 12.728L0.292282 7.07103C0.104811 6.8835 -0.000504971 6.62919 -0.000504971 6.36403C-0.000504971 6.09886 0.104811 5.84455 0.292282 5.65703Z" fill="white"/>
        </svg>
      </button>
      <button class="product-lightbox__nav next">
        <svg width="20" height="25" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.071 7.071L1.414 12.728L0 11.314L4.95 6.364L0 1.414L1.414 0L7.071 5.657C7.25847 5.84453 7.36379 6.09884 7.36379 6.364C7.36379 6.62916 7.25847 6.88347 7.071 7.071Z" fill="white"/>
        </svg>
      </button>
      <div class="product-lightbox__inner" tabindex="0">
        <img class="product-lightbox__img" alt="" />
        <div class="product-lightbox__video" hidden></div>
      </div>
      <div class="product-lightbox__controls">
        <button class="product-lightbox__btn zoom-out">−</button>
        <button class="product-lightbox__btn zoom-in">+</button>
      </div>
      <div class="product-lightbox__gallery">
        <div class="product-lightbox__thumbs"></div>
      </div>
    </div>`;
  const lightboxEl = tpl.firstElementChild;
  const lbImg = lightboxEl.querySelector(".product-lightbox__img");
  const videoWrapper = lightboxEl.querySelector(".product-lightbox__video");
  const btnClose = lightboxEl.querySelector(".product-lightbox__close");
  const btnZoomIn = lightboxEl.querySelector(".zoom-in");
  const btnZoomOut = lightboxEl.querySelector(".zoom-out");
  const thumbsBox = lightboxEl.querySelector(".product-lightbox__thumbs");
  const btnPrev = lightboxEl.querySelector(".product-lightbox__nav.prev");
  const btnNext = lightboxEl.querySelector(".product-lightbox__nav.next");
  document.body.appendChild(lightboxEl);

  // Semua elemen focusable di product lightbox
  const plFocusableEls = [
    btnClose,
    btnZoomIn,
    btnZoomOut,
    btnPrev,
    btnNext,
    lightboxEl.querySelector(".product-lightbox__inner"),
  ];

  function plSetFocusable(enabled) {
    plFocusableEls.forEach((el) => {
      if (!el) return;
      if (enabled) el.removeAttribute("tabindex");
      else el.setAttribute("tabindex", "-1");
    });
  }

  // Tidak focusable saat lightbox tertutup
  plSetFocusable(false);

  let currentIndex = 0;
  let currentScale = 1;
  let baseFitScale = 1;
  let offsetX = 0;
  let offsetY = 0;
  let isDragging = false;
  let lastTouchDist = 0;
  let naturalWidth = 0;
  let naturalHeight = 0;
  let currentItemType = "image";
  let velocityX = 0;
  let velocityY = 0;
  let lastMoveTime = 0;

  function getImgSrc(imgEl) {
    if (!imgEl) return "";
    return imgEl.currentSrc || imgEl.src || imgEl.getAttribute("src") || "";
  }

  function normalizeSrc(src) {
    if (!src) return "";
    try {
      const u = new URL(src, window.location.origin);
      u.search = "";
      u.hash = "";
      u.pathname = u.pathname.replace(/_[0-9]+x(\.[^/.]+)$/i, "$1");
      return u.toString();
    } catch (e) {
      return src.split("?")[0].replace(/_[0-9]+x(\.[^/.]+)$/i, "$1");
    }
  }

  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  const wrapperSelector =
    ".product__media-item, [data-product-media-type], [data-media-type]";
  let mediaWrappers = [];
  const galleryItems = [];
  const clickToIndex = new Map();
  const boundElements = new WeakSet();

  function buildMediaItem(wrapper) {
    if (!wrapper) return null;

    const typeAttr = (
      wrapper.getAttribute("data-product-media-type") ||
      wrapper.getAttribute("data-media-type") ||
      ""
    ).toLowerCase();

    const deferred = wrapper.matches("deferred-media")
      ? wrapper
      : wrapper.querySelector("deferred-media");
    const videoEl = wrapper.matches("video")
      ? wrapper
      : wrapper.querySelector("video");
    const iframeEl = wrapper.matches("iframe")
      ? wrapper
      : wrapper.querySelector("iframe");

    const looksLikeVideo =
      typeAttr.indexOf("video") !== -1 || !!deferred || !!videoEl || !!iframeEl;

    const thumbFromImg = getImgSrc(wrapper.querySelector("img"));

    if (looksLikeVideo) {
      if (iframeEl) {
        const src = iframeEl.src || iframeEl.getAttribute("src") || "";
        if (!src) return null;
        return {
          type: "video",
          mode: "iframe",
          iframeSrc: src,
          thumbSrc: thumbFromImg || "",
        };
      }

      if (deferred) {
        return {
          type: "video",
          mode: "template",
          deferred: deferred,
          thumbSrc: thumbFromImg || "",
          poster: "",
        };
      }

      if (videoEl) {
        const source = videoEl.querySelector("source");
        const videoSrc =
          (source &&
            (source.currentSrc || source.src || source.getAttribute("src"))) ||
          videoEl.currentSrc ||
          videoEl.src ||
          videoEl.getAttribute("src") ||
          "";
        if (!videoSrc) return null;
        const poster = videoEl.poster || videoEl.getAttribute("poster") || "";
        const thumb = poster || thumbFromImg;
        return {
          type: "video",
          mode: "direct",
          videoSrc: videoSrc,
          poster: poster,
          thumbSrc: thumb || "",
        };
      }
    }

    const imgEl = wrapper.matches("img")
      ? wrapper
      : wrapper.querySelector("img");
    const imgSrc = getImgSrc(imgEl);
    if (!imgSrc) return null;
    return { type: "image", src: imgSrc };
  }

  function pushItem(item, wrapper) {
    if (!item) return;
    const index = galleryItems.length;
    galleryItems.push(item);
    const clickables = wrapper.querySelectorAll(
      "img:not(.image-magnify-lightbox), video, button, [data-media-toggle]",
    );
    clickables.forEach((el) => clickToIndex.set(el, index));
  }

  function scanInitialMedia() {
    let wrappers = Array.from(
      document.querySelectorAll(".product__media-item"),
    );
    if (!wrappers.length)
      wrappers = Array.from(document.querySelectorAll(wrapperSelector));
    wrappers = wrappers.filter(function (el) {
      const parentWrapper =
        el.parentElement &&
        el.parentElement.closest(wrapperSelector + ", .product__media-item");
      return !parentWrapper;
    });

    mediaWrappers = wrappers;
    galleryItems.length = 0;
    clickToIndex.clear();

    mediaWrappers.forEach(function (wrapper) {
      const item = buildMediaItem(wrapper);
      pushItem(item, wrapper);
    });

    const descImgs = Array.from(
      document.querySelectorAll(
        ".product__description img, .rte img, .product-description img",
      ),
    );
    descImgs.forEach(function (img) {
      const src = getImgSrc(img);
      if (!src) return;
      const index = galleryItems.length;
      galleryItems.push({ type: "image", src: src });
      clickToIndex.set(img, index);
      img.style.cursor = "zoom-in";
    });
  }

  function computeBaseFitScale(w, h) {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    if (vw <= 640) return vw / w;
    const fitX = (vw * 0.7) / w;
    const fitY = (vh * 0.8) / h;
    return Math.min(fitX, fitY, 1);
  }

  function cleanupVideo() {
    const currentVideo = videoWrapper.querySelector("video, iframe");
    if (currentVideo && currentVideo.pause) {
      try {
        currentVideo.pause();
      } catch (e) {}
    }
    videoWrapper.innerHTML = "";
    videoWrapper.hidden = true;
    videoWrapper.style.display = "none";
  }

  function showItem(i) {
    if (i < 0 || i >= galleryItems.length) return;
    currentIndex = i;
    const item = galleryItems[i];
    currentItemType = item.type;

    cleanupVideo();
    lbImg.style.display = "";
    lbImg.style.transform = "translate3d(0,0,0) scale(1)";

    if (item.type === "video") {
      currentScale = 1;
      baseFitScale = 1;
      offsetX = offsetY = 0;
      lbImg.style.display = "none";
      videoWrapper.hidden = false;
      videoWrapper.style.display = "flex";

      let videoEl = null;

      if (item.mode === "template" && item.deferred) {
        const tpl = item.deferred.querySelector("template");
        if (tpl && tpl.content) {
          const clone = tpl.content.cloneNode(true);
          videoWrapper.appendChild(clone);
          videoEl = videoWrapper.querySelector("video");
        }
      } else if (item.mode === "direct" && item.videoSrc) {
        videoEl = document.createElement("video");
        videoEl.src = item.videoSrc;
        videoEl.controls = true;
        videoEl.autoplay = true;
        videoEl.muted = true;
        videoEl.playsInline = true;
        if (item.poster) videoEl.poster = item.poster;
        videoEl.style.maxWidth = "100%";
        videoEl.style.maxHeight = "100%";
        videoWrapper.appendChild(videoEl);
      } else if (item.mode === "iframe" && item.iframeSrc) {
        const iframe = document.createElement("iframe");
        iframe.src = item.iframeSrc;
        iframe.allowFullscreen = true;
        iframe.setAttribute("frameborder", "0");
        iframe.style.maxWidth = "100%";
        iframe.style.maxHeight = "100%";
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        videoWrapper.appendChild(iframe);
        videoEl = iframe;
      }

      if (videoEl && videoEl.play) {
        videoEl.play().catch(() => {});
      }

      updateThumbs();
      return;
    }

    // IMAGE
    const src = item.src;
    const preload = new Image();
    preload.onload = function () {
      naturalWidth = preload.naturalWidth;
      naturalHeight = preload.naturalHeight;
      baseFitScale = computeBaseFitScale(naturalWidth, naturalHeight);
      currentScale = baseFitScale;
      offsetX = offsetY = 0;
      lbImg.src = src;
      lbImg.style.display = "";
      videoWrapper.hidden = true;
      videoWrapper.style.display = "none";
      updateTransform();
      updateThumbs();
    };
    preload.src = src;
  }

  function openLightbox(i) {
    if (!galleryItems.length) return;
    currentIndex = typeof i === "number" ? i : 0;
    lightboxEl.classList.add("open");
    plSetFocusable(true);
    document.body.style.overflow = "hidden";
    buildThumbs();
    showItem(currentIndex);
    // focus for accessibility
    setTimeout(() => {
      const inner = lightboxEl.querySelector(".product-lightbox__inner");
      if (inner && inner.focus) inner.focus();
    }, 50);
  }

  function closeLightbox() {
    lightboxEl.classList.remove("open");
    plSetFocusable(false);
    document.body.style.overflow = "";
    cleanupVideo();
  }

  function next() {
    if (!galleryItems.length) return;
    currentIndex = (currentIndex + 1) % galleryItems.length;
    showItem(currentIndex);
  }

  function prev() {
    if (!galleryItems.length) return;
    currentIndex =
      (currentIndex - 1 + galleryItems.length) % galleryItems.length;
    showItem(currentIndex);
  }

  function buildThumbs() {
    thumbsBox.innerHTML = "";
    const used = new Set();

    galleryItems.forEach(function (item, i) {
      const raw =
        item.type === "video"
          ? item.thumbSrc || item.poster || item.src
          : item.src;
      if (!raw) return;

      const key = normalizeSrc(raw);
      if (used.has(key)) return;
      used.add(key);

      const t = document.createElement("img");
      t.src = raw;
      t.className = "product-lightbox__thumb";
      t.dataset.index = String(i);
      if (i === currentIndex) t.classList.add("active");
      t.addEventListener("click", function () {
        showItem(i);
      });
      thumbsBox.appendChild(t);
    });
  }

  function updateThumbs() {
    thumbsBox.querySelectorAll("img").forEach(function (t) {
      const idx = Number(t.dataset.index || "-1");
      t.classList.toggle("active", idx === currentIndex);
    });
  }

  function applyScale(scale) {
    if (currentItemType === "video") return;
    const prevScale = currentScale;
    currentScale = Math.max(baseFitScale, Math.min(scale, baseFitScale * 6));
    if (
      currentScale <= baseFitScale + 0.01 &&
      prevScale > baseFitScale + 0.02
    ) {
      offsetX = offsetY = 0;
    }
    updateTransform();
  }

  function clampProductOffsets() {
    if (currentItemType === "video") return;
    if (!naturalWidth || !naturalHeight) return;

    if (currentScale <= baseFitScale + 0.01) {
      offsetX = 0;
      offsetY = 0;
      return;
    }

    const vw = window.innerWidth || document.documentElement.clientWidth;
    const vh = window.innerHeight || document.documentElement.clientHeight;

    const displayedW = naturalWidth * currentScale;
    const displayedH = naturalHeight * currentScale;

    const overflowX = Math.max(0, (displayedW - vw) / 2);
    const overflowY = Math.max(0, (displayedH - vh) / 2);

    const maxOffsetX = overflowX / currentScale;
    const maxOffsetY = overflowY / currentScale;

    offsetX = Math.max(-maxOffsetX, Math.min(maxOffsetX, offsetX));
    offsetY = Math.max(-maxOffsetY, Math.min(maxOffsetY, offsetY));
  }

  function updateTransform() {
    if (currentItemType === "video") return;
    clampProductOffsets();
    lbImg.style.transform = `translate3d(${offsetX}px,${offsetY}px,0) scale(${currentScale})`;
  }

  // scroll zoom
  lightboxEl.addEventListener(
    "wheel",
    function (e) {
      if (!lightboxEl.classList.contains("open")) return;
      if (currentItemType === "video") return;
      e.preventDefault();

      const imgCenterX =
        (window.innerWidth || document.documentElement.clientWidth) / 2;
      const imgCenterY =
        (window.innerHeight || document.documentElement.clientHeight) / 2;
      const cursorX = e.clientX - imgCenterX;
      const cursorY = e.clientY - imgCenterY;

      const zoomFactor = e.deltaY < 0 ? 1.08 : 0.92;
      const newScale = currentScale * zoomFactor;
      const prevScale = currentScale;
      const prevOffsetX = offsetX;
      const prevOffsetY = offsetY;

      applyScale(newScale);

      const scaleRatio = currentScale / prevScale;
      offsetX = prevOffsetX - cursorX * (scaleRatio - 1);
      offsetY = prevOffsetY - cursorY * (scaleRatio - 1);

      if (currentScale <= baseFitScale + 0.01) {
        offsetX = offsetY = 0;
      }

      updateTransform();
    },
    { passive: false },
  );

  // Zoom buttons
  btnZoomIn.addEventListener("click", () => applyScale(currentScale * 1.25));
  btnZoomOut.addEventListener("click", () => applyScale(currentScale / 1.25));
  btnClose.addEventListener("click", closeLightbox);
  btnNext.addEventListener("click", next);
  btnPrev.addEventListener("click", prev);

  let dragStartX = 0,
    dragStartY = 0;
  lbImg.addEventListener("mousedown", function (e) {
    if (currentItemType === "video") return;
    if (currentScale <= baseFitScale) return;
    isDragging = true;
    dragStartX = e.clientX - offsetX;
    dragStartY = e.clientY - offsetY;
    lastMoveTime = Date.now();
    lbImg.style.cursor = "grabbing";
    e.preventDefault();
  });

  window.addEventListener("mousemove", function (e) {
    if (!isDragging || currentItemType === "video") return;
    const now = Date.now();
    const dt = now - lastMoveTime;
    const newX = e.clientX - dragStartX;
    const newY = e.clientY - dragStartY;
    velocityX = (newX - offsetX) / dt;
    velocityY = (newY - offsetY) / dt;
    offsetX = newX;
    offsetY = newY;
    updateTransform();
    lastMoveTime = now;
  });

  window.addEventListener("mouseup", function () {
    if (isDragging) {
      isDragging = false;
      lbImg.style.cursor = "grab";
    }
  });

  lbImg.addEventListener("touchstart", function (e) {
    if (currentItemType === "video") return;
    if (e.touches.length === 2) {
      lastTouchDist = getDistance(e.touches[0], e.touches[1]);
    } else if (e.touches.length === 1) {
      isDragging = true;
      dragStartX = e.touches[0].clientX - offsetX;
      dragStartY = e.touches[0].clientY - offsetY;
    }
  });

  lbImg.addEventListener(
    "touchmove",
    function (e) {
      if (currentItemType === "video") return;
      if (e.touches.length === 1 && isDragging) {
        e.preventDefault();
        offsetX = e.touches[0].clientX - dragStartX;
        offsetY = e.touches[0].clientY - dragStartY;
        updateTransform();
      } else if (e.touches.length === 2) {
        const dist = getDistance(e.touches[0], e.touches[1]);
        applyScale(currentScale * (dist / lastTouchDist));
        lastTouchDist = dist;
      }
    },
    { passive: false },
  );

  lbImg.addEventListener("touchend", function () {
    if (currentItemType === "video") return;
    isDragging = false;
  });

  function getDistance(t1, t2) {
    return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
  }

  function bindClickablesForWrappers(wrappers) {
    wrappers.forEach(function (wrapper) {
      const clickables = wrapper.querySelectorAll(
        "img, video, button, [data-media-toggle]",
      );
      clickables.forEach(function (el) {
        if (boundElements.has(el)) return;
        const idx = clickToIndex.get(el);
        if (typeof idx !== "number") return;
        el.style.cursor = "zoom-in";
        el.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          openLightbox(idx);
        });
        boundElements.add(el);
      });
    });
  }

  function bindDescImages() {
    const descImgs = Array.from(
      document.querySelectorAll(
        ".product__description img, .rte img, .product-description img",
      ),
    );
    descImgs.forEach(function (img) {
      if (boundElements.has(img)) return;
      const idx = clickToIndex.get(img);
      if (typeof idx !== "number") return;
      img.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(idx);
      });
      img.style.cursor = "zoom-in";
      boundElements.add(img);
    });
  }

  function rebuildGallery() {
    let newWrappers = Array.from(
      document.querySelectorAll(".product__media-item"),
    );
    if (!newWrappers.length)
      newWrappers = Array.from(document.querySelectorAll(wrapperSelector));
    newWrappers = newWrappers.filter((el) => {
      const p =
        el.parentElement &&
        el.parentElement.closest(wrapperSelector + ", .product__media-item");
      return !p;
    });

    mediaWrappers = newWrappers;
    galleryItems.length = 0;
    clickToIndex.clear();
    mediaWrappers.forEach((wrapper) => {
      const item = buildMediaItem(wrapper);
      pushItem(item, wrapper);
    });

    const descImgs = Array.from(
      document.querySelectorAll(
        ".product__description img, .rte img, .product-description img",
      ),
    );
    descImgs.forEach(function (img) {
      const src = getImgSrc(img);
      if (!src) return;
      const index = galleryItems.length;
      galleryItems.push({ type: "image", src: src });
      clickToIndex.set(img, index);
    });

    bindClickablesForWrappers(mediaWrappers);
    bindDescImages();

    if (lightboxEl.classList.contains("open")) {
      buildThumbs();
      if (currentIndex >= galleryItems.length) currentIndex = 0;
      showItem(currentIndex);
    }

    function rebuildGallery() {
      bindClickablesForWrappers(mediaWrappers);
      bindDescImages();
      bindMagnifyOverlay();
    }
  }

  const debouncedRebuild = debounce(rebuildGallery, 120);

  document.addEventListener("variant:change", function () {
    debouncedRebuild();
  });

  const mediaContainer = document.querySelector(
    "#ProductPhotos, .product__media, .product-media, [data-product-media-list], #ProductGallery, .product-gallery, .product__media-list",
  );
  if (mediaContainer) {
    const mo = new MutationObserver(
      debounce(function (mutations) {
        debouncedRebuild();
      }, 80),
    );
    mo.observe(mediaContainer, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  } else {
    const fallback = document.querySelector("#MainContent") || document.body;
    const mo2 = new MutationObserver(
      debounce(function () {
        debouncedRebuild();
      }, 150),
    );
    mo2.observe(fallback, { childList: true, subtree: true });
  }

  window.addEventListener("load", rebuildGallery);
  window.addEventListener(
    "resize",
    debounce(function () {
      if (lightboxEl.classList.contains("open")) buildThumbs();
    }, 200),
  );

  // Fix: redirect klik dari Shopify native zoom overlay ke custom lightbox
  function bindMagnifyOverlay() {
    document
      .querySelectorAll(".image-magnify-lightbox")
      .forEach(function (overlay) {
        if (overlay._jt_bound) return; // hindari double binding
        overlay._jt_bound = true;
        overlay.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          // Cari index gambar yang sesuai berdasarkan posisi wrapper-nya
          const wrapper = overlay.closest(".product__media-item");
          const imgs = wrapper
            ? wrapper.querySelectorAll("img:not(.image-magnify-lightbox)")
            : [];
          const targetImg = imgs[0];
          const idx = targetImg ? clickToIndex.get(targetImg) : 0;
          openLightbox(typeof idx === "number" ? idx : 0);
        });
      });
  }

  // Panggil setelah scan awal
  bindMagnifyOverlay();

  scanInitialMedia();
  bindClickablesForWrappers(mediaWrappers);
  bindDescImages();

  if (!galleryItems.length) return;

  lightboxEl.addEventListener("click", function (e) {
    if (e.target === lightboxEl) closeLightbox();
  });

  document.addEventListener("keydown", function (e) {
    if (!lightboxEl.classList.contains("open")) return;
    if (e.key === "Escape") {
      e.preventDefault();
      closeLightbox();
    }
    if (e.key === "ArrowRight") {
      e.preventDefault();
      next();
    }
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      prev();
    }
  });

  lightboxEl.addEventListener("keydown", function (e) {
    if (e.key === "Tab") {
      e.preventDefault();
      const inner = lightboxEl.querySelector(".product-lightbox__inner");
      if (inner) inner.focus();
    }
  });
})();
